<template>
    <div class="fzg-news-mobile">
      <div class="fzg-banner">
        <fzg-menu/>
        <img class="m-banner" src="../../assets/img2/mobile/news/banner.jpg" alt="">
      </div>

      <div class="news-deal">
        <img class="main-title" src="../../assets/img2/mobile/news/title_trans.png" alt="">
        <div class="deal-list">

          <a class="deal-item" v-for="item in dealList" :href="item.link" target="_blank" >
            <div class="logo-area">
              <img class="logo" :src="item.banner">
            </div>
            <div class="title">{{ item.title }}</div>
          </a>
        </div>
      </div>


      <div class="fzg-recent-activity">
        <a name="activity"></a>
        <img class="activity-title" src="../../assets/img2/mobile/news/title_activity.png" alt="">
        <div class="fzg-activity-wrap">
          <div class="activity-left">
            <a :href="firstActivityNews.link" target="_blank" >
              <img :src="firstActivityNews.banner" alt="">
              <div class="l-title-area">
                <div class="l-date">{{firstActivityNews.date}} </div>
                <div class="l-title" v-if="firstActivityNews.title">{{firstActivityNews.title.length > 50 ? firstActivityNews.title.substr(0,50) + '...' : firstActivityNews.title }}</div>
              </div>
            </a>
          </div>
          <div class="activity-right">

            <div class="right-item"
              v-for="(item,index) in activityNewsList"
              v-if="index > 0 && index < 4">
              <a :href="item.link" target="_blank">
                <div class="r-item-date">{{ item.date }} </div>
                <div class="r-item-title">{{ item.title.substr(0,40) }}</div>
                <div class="r-item-content">{{ item.brief.length > 50 ? item.brief.substr(0,50) + '...' : item.brief }}</div>
              </a>
            </div>

          </div>
        </div>
      </div>

      <div class="fzg-activity">
        <img class="title-activity" src="../../assets/img2/mobile/news/title_news.png" alt="">
        <div class="activity-area">
          <a class="act-item"  v-for="item in groupNewsList" :href="item.link" target="_blank">
            <div class="act-icon">
              <img :src="item.banner">
            </div>
            <div class="right-content">
              <div class="act-title">{{ item.title }}</div>
            </div>
          </a>
        </div>
        <div class="page-num">
          <span v-for="page in groupNewsPageData.total_page"
            :class="{'active': page == currentNewsPage}"
            @click="changeNewsPage(page)"> {{ page }}</span>
        </div>

      </div>
    </div>
</template>

<script>

import util from '../../assets/js/util'
import FzgMenu from '../common/FzgMenuMobile.vue'

export default{
    components:{
      FzgMenu
    },
    props:[''],
    data(){
      return {
        activeCompany: 1,
        dealList: [],
        activityNewsList: [],
        firstActivityNews: {},
        groupNewsList: [],
        currentNewsPage: 1,
        groupNewsPageData: {},
      }
    },
    methods:{
      initView() { },
      getDealList() {
        var self = this
        util.resource({
            url: '/api/fzg/deal_news/',
            method: 'get',
            data: {
              p: 1,
              n: 100,
            },
            success (res) {
              if (res.code == 200) {
                self.dealList = res.data.list
              }
            }
        })
      },
      getActivityNewsList() {
        var self = this
        util.resource({
            url: '/api/fzg/activity_news/',
            method: 'get',
            data: {
              p: 1,
              n: 100,
            },
            success (res) {
              if (res.code == 200) {
                self.activityNewsList = res.data.list
                if (self.activityNewsList.length > 0) {
                  self.firstActivityNews = self.activityNewsList[0]
                }
              }
            }
        })
      },
      getGroupNewsList() {
        var self = this
        util.resource({
            url: '/api/fzg/group_news/',
            method: 'get',
            data: {
              p: self.currentNewsPage,
              n: 4,
            },
            success (res) {
              if (res.code == 200) {
                self.groupNewsList = res.data.list
                self.groupNewsPageData = res.data.page
              }
            }
        })
      },
      changeNewsPage(page) {
        this.currentNewsPage = page
        this.getGroupNewsList()
      }
    },
    mounted(){
      this.getDealList()
      this.getActivityNewsList()
      this.getGroupNewsList()
    },
    watch: {
    },

}
</script>

<style lang="scss" scoped>
.fzg-news-mobile {
  .fzg-banner {
    // border: 1px solid red;
    position: relative;
    .m-banner {
      width: 100%;
    }
  }

  .news-deal {
    border: 1px solid #ffffffff;
    display: block;
    width: 93%;
    margin: 30px auto 30px;
    position: relative;
    .main-title {
      width: 100px;
      margin: 0 auto;
      display: block;
    }
    .deal-list {
      // border: 1px solid #ccc;
      margin: 20px auto 30px;
      width: 100%;
      height: 630px;
      overflow-y: scroll;
      padding-right: 10px;
      &::-webkit-scrollbar {
        width: 6px;
        background-color: #ffffffff;
      }

      /* 改变滚动条的滑块颜色 */
      &::-webkit-scrollbar-thumb {
        border-radius: 4px;
        background-color: #d7ad78;
      }

      .deal-item {
        // background-color: #f5f5f5;
        text-align: left;
        width: 100%;
        height: 100px;
        cursor: pointer;
        border-bottom: 1px solid #ccc;
        display: table;
        .logo-area {
          // border: 1px solid red;
          display: table-cell;
          vertical-align:middle;
          width: 80px;
          height: 60px;
          overflow: hidden;
          .logo {
            // border: 1px solid gray;
            object-fit: cover;
            margin: 5px 10px 0;
            width: 80px;
            height: 60px;
          }
        }
        .title{
          // border: 1px solid red;
          display:table-cell;
          vertical-align:middle;
          font-size: 13px;
          color: #444444;
          line-height: 1.5;
          overflow:hidden;
          padding-left: 20px;
          text-overflow: ellipsis;
          padding: 10px 0;
          &:hover {
            color: #d7ad78;
          }
        }
        &:last-child {
          border-bottom: none; //  1px solid #ccc;
        }
      }
    }
  }

  .fzg-recent-activity{
    // border: 1px solid blue;
    margin: 0 auto;
    overflow: auto;
    position: relative;
    background: #f8f9fe;
    .activity-title {
      // border:  1px solid #ce262f;
      width: 100px;
      display: block;
      margin: 40px auto 20px;
    }
    .fzg-activity-wrap {
      // border: 1px solid blue;
      width: 90%;
      margin: 0 auto 40px;
      text-align: left;
      color: #575758;
      font-size: 16px;
      .activity-left {
        // border: 1px solid red;
        display: inline-block;
        width: 100%;
        height: auto;
        background: #ededed;
        // margin-right: 5px;
        overflow: hidden;
        position: relative;
        img {
          width: 100%;
          height: auto;
        }
        .l-title-area {
            // border: 1px solid red;
            background-color: #2d333a;
            opacity: 0.85;
            position: absolute;
            width: 100%;
            left: 0;
            bottom: 0;
            text-align: left;
          .l-date {
            margin-top: 15px;
            font-size: 18px;
            padding: 5px 20px;
            color: white;
            font-weight: bold;
          }
          .l-title {
            font-size: 14px;
            padding: 5px 20px 10px;
            color: white;
            margin-bottom: 20px;
          }
        }
      }
      .activity-right {
        // border: 1px solid red;
        display: block;
        // width: 330px;
        // min-height: 300px;
        .right-item {
          background: white;
          position: relative;
          overflow: hidden;
          padding: 10px 15px;
          margin-bottom: 2px;
          img {
            width: auto;
            height: 100%;
            overflow: hidden;
          }
          .r-item-date {
            font-size: 18px;
            font-weight: bold;
            color: #d7ad78;
            margin-top: 0px;
          }
          .r-item-title {
            // border: 1px solid red;
            text-align: left;
            color: #444444;
            font-size: 14px;
            margin-top: 5px;
          }
          .r-item-content {
            // border: 1px solid red;
            text-align: left;
            // color: #878787;
            color: #a3a3a3;
            font-size: 12px;
            margin-top: 5px;
          }
          &:hover {
            .r-item-title{
              color: #d7ad78;
            }
          }
        }
      }
    }
  }

  .fzg-activity{
    position: relative;
    overflow: auto;
    // border: 1px solid green;
	  // background-color: #f5f2ef;
    margin-top: 50px;
    .title-activity {
      // border: 1px solid #ce262f;
      width: 100px;
      margin: 0 auto;
      display: block;
    }
    .activity-area {
      // border: 1px solid green;
      margin: 20px auto 10px;
      display: flex;
      flex-flow: row wrap;
      // justify-content: space-around;
      justify-content: flex-start;
      .act-item {
        // border: 1px solid #ccc;
        width: 100%;
        background: #f7f7f7;
        margin: 10px;
        display: table;
        .act-icon {
          display: table-cell;
          width: 30%;
          height: 100%;
          overflow: hidden;
          text-align: center;
          position: relative;
          img {
            object-fit: contain;
            width: 100%;
            vertical-align: middle;
          }
        }
        .right-content {
          // border: 1px solid #ccc;
          text-align: left;
          display: table-cell;
          vertical-align: middle;
          width: 68%;
          overflow: hidden;
          padding: 0 10px;
          &:hover {
            color: #d7ad78;
          }
          .act-title {
            // border: 1px solid red;
            font-size: 14px;
            font-weight: bold;
            margin-top: 0px;
            vertical-align: middle;
          }
          .act-content {
            font-size: 12px;
            margin-top: 6px;
            color: #444444;
            line-height: 1.4;
          }
        }
      }
    }
    .page-num {
      // border: 1px solid red;
      width: 100%;
      height: 40px;
      line-height: 40px;
      text-align: center;
      margin: 10px auto 20px;
      span {
        cursor: pointer;
        padding: 5px 10px;
      }
      .active {
        color: #d7ad78;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// FzgNewsMobile.vue?561d48ca